// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse {
    static getAttributeTypeMap() {
        return CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse.attributeTypeMap;
    }
}
CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse.discriminator = undefined;
CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentPatientLookupResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=couponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse.js.map